export type CampaignLayerMethod = 'amount' | 'percent' | 'threshold'

export interface CampaignLayer {
  id: string
  name: string
  method: CampaignLayerMethod
  value: number
  threshold: number | null
  platformSharePercent: number
}

export interface CampaignItem {
  jdSkuId: string
  basePrice: number | null
  cpsCommissionPercent: number | null
}

export interface Campaign {
  id: string
  name: string
  startDate: string
  endDate: string
  note: string
  cpsCommissionPercent: number
  layers: CampaignLayer[]
  items: CampaignItem[]
}

export interface CampaignAnalysisData {
  schemaVersion: string
  updatedAt: string
  campaigns: Campaign[]
}

export const campaignCpsCommission = (finalPrice: number | null, commissionPercent: number) =>
  finalPrice === null ? null : finalPrice * commissionPercent / 100

export const resolvedCampaignItemCpsPercent = (
  itemCommissionPercent: number | null | undefined,
  campaignCommissionPercent: number,
) => itemCommissionPercent ?? campaignCommissionPercent

export async function loadCampaigns(): Promise<CampaignAnalysisData | null> {
  try {
    const response = await fetch('/data/campaign-analysis.json', { cache: 'no-store' })
    if (!response.ok) throw new Error(`HTTP ${response.status}`)
    return await response.json() as CampaignAnalysisData
  } catch {
    return null
  }
}

export async function saveCampaigns(
  campaigns: Campaign[],
  request: typeof fetch = fetch,
): Promise<CampaignAnalysisData> {
  const response = await request('/api/campaign-analysis/campaigns', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ campaigns }),
  })
  const payload = await response.json()
  if (!response.ok) throw new Error(payload?.error || `HTTP ${response.status}`)
  return payload as CampaignAnalysisData
}
